module.exports = __webpack_public_path__ + "static/media/sell_finish_service_help_3.041b0c00.jpg";